import { render, staticRenderFns } from "./CMQuickReserve.vue?vue&type=template&id=8b6e6bd2&lang=pug"
import script from "./CMQuickReserve.vue?vue&type=script&lang=js"
export * from "./CMQuickReserve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports